export class FormViewModel {
    id: string;

    title: string;

    description: string;

    fields: any[];
}
